export const FEATURE_NAMESPACE = 'feature'

// Actions
export const SET_SESSION_STORAGE_SWITCH = 'SET_SESSION_STORAGE_SWITCH'

// Mutations
export const SWITCH = 'SWITCH'
export const SWITCH_VALUE = 'SWITCH_VALUE'
export const SWITCH_AND_VALUE = 'SWITCH_AND_VALUE'
